<template>
  <div class="acvitity_foot_left_group">
    <template v-if="$route.name !== 'learningGuide' && iconShow">
      <div class="custom" @click="consultingClick">
        <img src="../../../assets/img/productDetail/icon_custom.png" alt />
        <p class>咨询</p>
      </div>
      <div class="community" @click="openPopup" v-if="communityType">
        <img
          :src="require(`../../../assets/img/productDetail/${communityList[communityType].imgUrl}`)"
          alt
        />
        <p>{{ communityList[communityType].title }}</p>
      </div>
      <div v-else></div>
      <!-- 购物车 点击进入购物车列表页-->
      <div class="carIconBtn" @click="goShoppingCar">
        <img src="../../../assets/img/productDetail/carIcon.png" alt />
        <i class="carNum" v-if="cartCount">{{ cartCount }}</i>
        <span>购物车</span>
      </div>
    </template>
    <van-popup v-model="showPop" position="bottom" :get-container="getContainer">
      <div class="close-btn" @click="showPop = false">
        <van-icon name="cross" />
      </div>
      <component
        v-if="showPop"
        :is="communityType | typeToComponentName"
        :communityInfo="communityInfo"
      />
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { reqCourseCommunitySku } from '@/api/courseDetail/community/community';
import qqPopupComponent from '@/components/courseDetail/footCommuntiy/qqPopupComponent.vue';
import wxPopupComponent from '@/components/courseDetail/footCommuntiy/wxPopupComponent.vue';

export default {
  components: { qqPopupComponent, wxPopupComponent },
  filters: {
    /** 根据type找到组件 */
    typeToComponentName(val) {
      let componentName;
      if (val === '1-1' || val === '1-2') {
        componentName = 'qqPopupComponent';
      } else if (val === '2-1' || val === '2-2' || val === 'wxAccount') {
        componentName = 'wxPopupComponent';
      }
      return componentName || '';
    },
  },
  props: {
    skuInfo: {
      type: Object,
      default: () => ({}),
    },
    iconShow: {
      type: Boolean,
      default: true,
    },
    buyInfo: {
      type: Object,
      default: () => ({}),
    },
    cartCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showPop: false,
      communityList: {
        '1-1': {
          imgUrl: 'icon_qq.png',
          title: '一键加群',
          platform: 1, // 社交平台 1qq 2微信
          integer: 1, // 账号类型 1群号 2个人号
        },
        '1-2': {
          imgUrl: 'icon_qq.png',
          title: '添加助教',
          platform: 1,
          integer: 2,
        },
        '2-1': {
          imgUrl: 'icon_wechat.png',
          title: '加入微信群',
          platform: 2,
          integer: 1,
        },
        '2-2': {
          imgUrl: 'icon_teacher_wx.png',
          title: '添加老师微信',
          platform: 2,
          integer: 2,
        },
        wxAccount: {
          imgUrl: 'icon_wx_account.png',
          title: '关注公众号',
          platform: 1,
          integer: 1,
        },
      },
      communityType: '', // 社群按钮类型
      communityInfo: {}, // 社群详情信息
    };
  },
  computed: {
    ...mapState(['productSku']),
  },
  watch: {
    productSku() {
      // 监听sku选择的变化，更新社群信息
      this.getCourseCommunitySku();
    },
  },
  created() {},
  mounted() {
    if (this.buyInfo?.skuId) {
      const { productId, skuId } = this.buyInfo;
      this.getReqCourseCommunitySku(productId, skuId);
    } else {
      this.getCourseCommunitySku();
    }
  },
  methods: {
    getContainer() {
      return document.querySelector('.acvitity_foot_left_group');
    },
    openPopup(val) {
      if (val === 'default') {
        this.communityType = 'wxAccount';
        this.communityInfo = {};
      }
      this.showPop = true;
    },
    async learnGuideOpen() {
      await this.getCourseCommunitySku();
    },
    async getCourseCommunitySku() {
      let courseId;
      let productSkuId;
      if (this.skuInfo.skuId) {
        courseId = this.skuInfo.productId;
        productSkuId = this.skuInfo.skuId;
      } else if (this.buyInfo.skuId) {
        const { productId, skuId } = this.buyInfo;
        courseId = productId;
        productSkuId = skuId;
      } else {
        courseId = this.$route.query.courseId;
        productSkuId = this.productSku.productSkuId;
      }
      if (!productSkuId) {
        return;
      }
      await this.getReqCourseCommunitySku(courseId, productSkuId);
      this.showPop = true;
    },
    async getReqCourseCommunitySku(courseId, productSkuId) {
      const request = await reqCourseCommunitySku(courseId, productSkuId);
      this.communityInfo = request.data;
      if (request.code === 0 && request.data) {
        const { data } = request;
        this.communityType = `${data.platform}-${data.accountType}`;
        this.$emit('accountType', data.accountType);
      } else {
        this.communityType = 'wxAccount';
      }
    },
    consultingClick() {
      let url =
        'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=6194a29668991d6b4e202137';
      if (this.$route.query.source === 'vipCourse') {
        url =
          'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=665818671c64a1000119f4b2';
      }
      if (this.$route.query.source === 'vipCourse' && this.$root.$data.isApp) {
        url =
          'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=66696197735feb0001e5a925';
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram && this.$route.query.source) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: '/subPackages/mantisChat/mantisChat',
        });
        return;
      }
      window.open(url);
    },
    // 查看购物车列表
    goShoppingCar() {
      this.$emit('lookShopCar');
    },
  },
  destroyed() {},
};
</script>
<style scoped lang="scss">
.acvitity_foot_left_group {
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  ::v-deep .van-popup {
    border-radius: 14px 14px 0 0;
  }

  .close-btn {
    position: absolute;
    top: 67px;
    right: 29px;
    z-index: 999;
    display: flex;
    color: #a8a8a8;

    i {
      font-size: 40px;
    }
  }

  .custom {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .custom,
  .community {
    margin-right: 34px;
    img {
      display: block;
      width: 43px;
      margin: 0 auto;
    }
    p {
      margin-top: 2px;
      color: #333;
      font-size: 18px;
      line-height: 28px;
    }
  }
  .carIconBtn {
    position: relative;
    img {
      display: block;
      width: 44px;
      height: 44px;
      margin: 0 auto;
    }
    span {
      display: block;
      color: #333;
      font-weight: 400;
      font-size: 20px;
      line-height: 30px;
    }
    .carNum {
      position: absolute;
      top: -10px;
      right: 0;
      display: block;
      width: 30px;
      height: 30px;
      color: #fff;
      font-weight: 500;
      font-size: 18px;
      font-style: normal;
      line-height: 30px;
      text-align: center;
      background: #ff472d;
      border: 2px solid #fff;
      border-radius: 50%;
    }
  }
}
</style>
